function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#636365",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.243 0h-4.569a.726.726 0 0 0 0 1.452h2.817l-7.472 7.47A.726.726 0 1 0 7.046 9.95l7.471-7.47v2.727a.726.726 0 0 0 1.452 0V.726c0-.401-.325-.726-.726-.726z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.34 7.259c-.401 0-.726.325-.726.725v6.533H1.452V4.355h6.532a.726.726 0 0 0 0-1.452H.726c-.401 0-.726.325-.726.726v11.614c0 .4.325.726.726.726H12.34c.4 0 .725-.325.725-.726V7.984c0-.4-.325-.725-.725-.725z"
}));

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.8f4d1066.svg";
export { ForwardRef as ReactComponent };